var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

// js/common/utilities/format-money.js
function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

const bundleMinProductsRequirement = parseInt(document.querySelector(".pick-and-mix").dataset.minProductRequirements)
const bundleFreeProducts = document.querySelector(".pick-and-mix").dataset.freeProducts?.split(',').map(el => parseInt(el.trim()));
const bundleFreeProductMessage = document.querySelector("#pick-and-mix--free-product-message");
const footerRecap = document.querySelector(".pick-and-mix--products")
const bundleProductsQtyMessage = document.querySelector(".pick-and-mix--recap-info-qty-content");
const footerRecapEmptyStateMessage = document.querySelector("#pick-and-mix--products-suggestion-message");
const bundleForm = document.getElementById("bundle-form")
const weiterButton = document.querySelector(".pick-and-mix--footer button[type='button']")
const toggleProductsVisibility = document.querySelector(".pick-and-mix--footer button#pick-and-mix--toggle-products-visibility")
const toggleInfoButton = document.querySelector(".pick-and-mix--footer button#pick-and-mix--info-button")
const toggleInfoContentWrapper = document.querySelector(".pick-and-mix--footer .pick-and-mix--info-wrapper")
const bundleProductId = bundleForm.querySelector("input[name='id']").value
const bundleProgressBar = document.querySelector(".pick-and-mix--footer .scrollbar__progress#bundle-progress")
const bundleProgressBarContainer = document.querySelector(".pick-and-mix--bundle-progress-bar")
const bundleProducts = document.querySelectorAll("product-card")
const bundlePrice = parseInt(document.querySelector(".pick-and-mix").dataset.bundleStartingPrice)

const lessThanMinProductsMessage = `VON ${bundleMinProductsRequirement} AUSGEWÄHLT`
const moreThanMinProductsMessage = "AUSGEWÄHLT"

let items = [];
bundleProducts.forEach(productCard => {
  const productInfo = {
    id: productCard.dataset.variantId,
    sku: productCard.dataset.variantSku,
    price: parseInt(productCard.querySelector("[data-price]").dataset.price),
    maxAvailability: parseInt(productCard.dataset.maxAvailability),
    packaging: productCard.dataset.packaging === "true",
    title: productCard.querySelector(".product-card__title").textContent
  }

  productCard.addEventListener("click", () => updateOrAddItem(productCard, productInfo))
})

totalItems = () => {
  return items.reduce((total, item) => total + (item.packaging === false ? item.quantity : 0), 0);
}

currentStep = () => {
  return document.querySelector(".pick-and-mix").dataset.currentStep;
}

function updateOrAddItem(productCard, productInfo) {
  const id = productInfo.id
  const existingItem = items.find(item => item.id === id);
  footerRecapEmptyStateMessage.style.display = "none"

  if (existingItem) {
    if(productInfo.packaging === true) return;

    if ((existingItem.quantity + 1) > productInfo.maxAvailability) return;
    else if ((existingItem.quantity + 1) == productInfo.maxAvailability) {
      productCard.classList.add("pick-and-mix--product-not-available");
    } else {
      productCard.classList.remove("pick-and-mix--product-not-available");
    }

    // If the item exists, increase its quantity by 1
    if (!bundleFreeProducts || !bundleFreeProducts.includes(totalItems() + 1) || productInfo.packaging === true) {
      existingItem.price += productInfo.price;
    }
    existingItem.quantity += 1;
    updateBundleProgress();
    updateProductsCount();
    updateTotal();
    footerRecap.querySelector(`[data-variant-id="${id}"] .count-bubble`).textContent = existingItem.quantity;
    footerRecap.querySelector(`[data-variant-id="${id}"] .quantity-selector__input`).value = existingItem.quantity;
  } else {
    if(productInfo.packaging === true) {
      // remove the old packaging before adding the new selection
      const existingPackagingProduct = items.find(item => item.packaging === true);

      if(existingPackagingProduct) {
        items = items.filter(item => item.id !== existingPackagingProduct.id);

        document.querySelector(`.pick-and-mix--footer-product-card[data-variant-id="${existingPackagingProduct.id}"]`).remove();
        updateTotal();
      }
    }

    // If the item doesn't exist, add it with quantity set to 1
    const price = !bundleFreeProducts || !bundleFreeProducts.includes(totalItems() + 1) || productInfo.packaging === true ? productInfo.price : 0
    items.push({ id: productInfo.id, title: productInfo.title, quantity: 1, sku: productInfo.sku, price, packaging: productInfo.packaging });
    updateBundleProgress();
    updateProductsCount();
    updateTotal();

    const productImg = productCard.querySelector(".product-card__figure img").cloneNode(true);
    productImg.srcSet = "";
    
    const footerProductCard = document.createElement("div");
    footerProductCard.dataset.variantId = id;
    const productImgComponent = document.createElement("div");
    productImgComponent.classList.add("pick-and-mix--product-image");
    productImgComponent.appendChild(productImg);
    
    const cartCountDiv = document.createElement("div");
    cartCountDiv.classList.add("pick-and-mix--product-count-bubble");

    const cartCount = document.createElement("div");
    cartCount.classList.add("count-bubble", "count-bubble--lg");
    cartCount.setAttribute("aria-hidden", "true");
    cartCount.textContent = 1;

    cartCountDiv.appendChild(cartCount);
    productImgComponent.appendChild(cartCountDiv);

    footerProductCard.classList.add("relative", "pick-and-mix--footer-product-card")
    footerProductCard.appendChild(productImgComponent);
    
    if(productInfo.packaging === false) {
      const qtyButtonsDiv = document.createElement("div");
      qtyButtonsDiv.classList.add("pick-and-mix--product-quantity-buttons-tooltip");
      qtyButtonsDiv.innerHTML = `
        <div class="quantity-selector">
          <input id="product-form-8978451300592-template--18669941391600__main-quantity" type="text" inputmode="numeric" class="quantity-selector__input" name="quantity" form="product-form-8978451300592-template--18669941391600__main" size="2" value="1" autocomplete="off">
          <button type="button" class="quantity-selector__button" aria-label="Increase quantity">
            <svg role="presentation" focusable="false" stroke-width="2" width="10" height="10" class="icon icon-plus" viewBox="0 0 12 12"><path d="M6 0V12" fill="none" stroke="currentColor"></path><path d="M0 6L12 6" fill="none" stroke="currentColor"></path></svg>
          </button>
        </div>
      `;
      footerProductCard.appendChild(qtyButtonsDiv);

      footerProductCard.addEventListener("mouseover", (e) => {

        if(!qtyButtonsDiv.classList.contains("visible") && productInfo.packaging === false && currentStep() === "2") {
          qtyButtonsDiv.classList.add("visible");
        }
      });

      footerProductCard.addEventListener("mouseout", (e) => {

        if(qtyButtonsDiv.classList.contains("visible")) {
          qtyButtonsDiv.classList.remove("visible");
        }
      });

      footerProductCard.querySelector("input.quantity-selector__input").addEventListener("change", (e) => {
        e.stopPropagation()
        const thisFooterProductCard = e.target.closest("[data-variant-id]");
        const id = thisFooterProductCard.dataset.variantId;
        const existingItem = items.find(item => item.id === id);
        const newQuantity = parseInt(e.target.value) || existingItem.quantity;

        if (newQuantity <= existingItem.quantity) {
          footerProductCard.querySelector("input.quantity-selector__input").value = existingItem.quantity;
          return;
        }

        if (existingItem) {
          const isPackagingProduct = existingItem.packaging === true

          if (!isPackagingProduct && currentStep() === "3") return;

          if (newQuantity > productInfo.maxAvailability) {
            footerProductCard.querySelector("input.quantity-selector__input").value = productInfo.maxAvailability;
            var event = new Event('change');
            footerProductCard.querySelector("input.quantity-selector__input").dispatchEvent(event);
            return;
          } else if (newQuantity == productInfo.maxAvailability) {
            productCard.classList.add("pick-and-mix--product-not-available");
          } else {
            productCard.classList.remove("pick-and-mix--product-not-available");
          }

          
          const difference = newQuantity - existingItem.quantity;
          for(let i = 1; i <= difference; i++) {
            existingItem.quantity++;

            if (!bundleFreeProducts || !bundleFreeProducts.includes(totalItems())) {
              existingItem.price += productInfo.price;
            }
          }

          updateBundleProgress();
          updateProductsCount();
          updateTotal();

          if (existingItem.quantity > 0) {
            thisFooterProductCard.querySelector(".count-bubble").textContent = existingItem.quantity;
            thisFooterProductCard.querySelector(".quantity-selector__input").value = existingItem.quantity;
          } else {
            items = items.filter(item => item.id !== id);
            thisFooterProductCard.remove();
          }

          if (totalItems() === 0) {
            footerRecapEmptyStateMessage.style.display = ""
          }

          if (totalItems() < bundleMinProductsRequirement) {
            weiterButton.disabled = true;
            weiterButton.textContent = weiterButton.dataset.defaultLabel;
            document.getElementById("pick-and-mix--total-ptoducts-message").textContent = lessThanMinProductsMessage;
          } else {
            weiterButton.disabled = false;
            weiterButton.textContent = weiterButton.dataset.successLabel;
            document.getElementById("pick-and-mix--total-ptoducts-message").textContent = moreThanMinProductsMessage;
        
            const packagingProduct = items.find(item => item.packaging === true)
            if (packagingProduct?.quantity > 0) {
              bundleForm.querySelector("button[type='submit']").disabled = false;
            } else {
              bundleForm.querySelector("button[type='submit']").disabled = true;
            }
          }

          const packagingProduct = items.find(item => item.packaging === true)
          if (packagingProduct?.quantity > 0) {
            bundleForm.querySelector("button[type='submit']").disabled = false;
          } else {
            bundleForm.querySelector("button[type='submit']").disabled = true;
          }
        } else {
          console.error("Having trouble decreasing the quantity of products");
        }
      });
      footerProductCard.querySelector("button.quantity-selector__button").addEventListener("click", (e) => {
        e.stopPropagation()
        const thisFooterProductCard = e.target.closest("[data-variant-id]");
        const id = thisFooterProductCard.dataset.variantId;
        const existingItem = items.find(item => item.id === id);

        if (existingItem) {
          const isPackagingProduct = existingItem.packaging === true

          if (!isPackagingProduct && currentStep() === "3") return;

          if ((existingItem.quantity + 1) > productInfo.maxAvailability) return;
          else if ((existingItem.quantity + 1) == productInfo.maxAvailability) {
            productCard.classList.add("pick-and-mix--product-not-available");
          } else {
            productCard.classList.remove("pick-and-mix--product-not-available");
          }

          existingItem.quantity += 1;
          if (!bundleFreeProducts || !bundleFreeProducts.includes(totalItems())) {
            existingItem.price += productInfo.price;
          }
          updateBundleProgress();
          updateProductsCount();
          updateTotal();

          thisFooterProductCard.querySelector(".count-bubble").textContent = existingItem.quantity;
          thisFooterProductCard.querySelector(".quantity-selector__input").value = existingItem.quantity;

          if (totalItems() >= bundleMinProductsRequirement) {
            weiterButton.disabled = false;
            weiterButton.textContent = weiterButton.dataset.successLabel;
            document.getElementById("pick-and-mix--total-ptoducts-message").textContent = moreThanMinProductsMessage;
        
            const packagingProduct = items.find(item => item.packaging === true)
            if (packagingProduct?.quantity > 0) {
              bundleForm.querySelector("button[type='submit']").disabled = false;
            } else {
              bundleForm.querySelector("button[type='submit']").disabled = true;
            }
          }

          const packagingProduct = items.find(item => item.packaging === true)
          if (packagingProduct?.quantity > 0) {
            bundleForm.querySelector("button[type='submit']").disabled = false;
          } else {
            bundleForm.querySelector("button[type='submit']").disabled = true;
          }
        } else {
          console.error("Having trouble decreasing the quantity of products");
        }
      });
    }

    footerRecap.querySelector("bundle-builder-slider").appendChild(footerProductCard);
  }

  document.addEventListener("click", (e) => {
    document.querySelectorAll(".pick-and-mix--product-quantity-buttons-tooltip")
      .forEach(tooltip => {
        if(!tooltip.closest(".pick-and-mix--footer-product-card").contains(e.target)) {
          tooltip.classList.remove("visible")
        }
      })
  })

  if (totalItems() >= bundleMinProductsRequirement) {
    weiterButton.disabled = false;
    weiterButton.textContent = weiterButton.dataset.successLabel;
    document.getElementById("pick-and-mix--total-ptoducts-message").textContent = moreThanMinProductsMessage;

    const packagingProduct = items.find(item => item.packaging === true)
    if (packagingProduct?.quantity > 0) {
      bundleForm.querySelector("button[type='submit']").disabled = false;
    } else {
      bundleForm.querySelector("button[type='submit']").disabled = true;
    }
  }
}

weiterButton.addEventListener("click", () => {
  window.scrollTo({top: 0, behavior: 'smooth'});
  document.querySelector(".pick-and-mix").dataset.currentStep = 3;
})

toggleProductsVisibility.addEventListener("click", () => {
  if(footerRecap.classList.contains("pick-and-mix--hide-desktop")) {
    footerRecap.classList.remove("pick-and-mix--hide-desktop");
    toggleProductsVisibility.textContent = toggleProductsVisibility.dataset.hideLabel
  } else {
    footerRecap.classList.add("pick-and-mix--hide-desktop");
    toggleProductsVisibility.textContent = toggleProductsVisibility.dataset.showLabel
  }
});

toggleInfoButton.addEventListener("click", () => {
  if(toggleInfoContentWrapper.classList.contains("hidden")) {
    toggleInfoContentWrapper.classList.remove("hidden");
    toggleInfoButton.textContent = toggleInfoButton.dataset.hideLabel
  } else {
    toggleInfoContentWrapper.classList.add("hidden");
    toggleInfoButton.textContent = toggleInfoButton.dataset.showLabel
  }
});

bundleForm.addEventListener("submit", async (e) => {
  e.preventDefault()

  const visibleProperties = items
  .filter(item => item.packaging === false)
  .reduce((acc, item) => {
    acc[`${item.quantity}x ${item.title}`] = "Pick & Mix";
    return acc;
  }, {});


  const bundleProduct = {
    id: bundleProductId,
    quantity: 1,
    properties: {
      _uId: 'uid-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9),
      _bundleProducts: JSON.stringify(items),
      _content: items.map(item => `${item.quantity}x${item.sku}`),
      _totalProducts: totalItems(),
      ...visibleProperties
    }
  }

  const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      items: [bundleProduct]
    })
  })

  if (response.ok) {
    window.location.replace(`${Shopify.routes.root}pages/pick-mix-success`);
  }
})

function countConsecutiveBefore(array, target) {
  let count = 0;

  for (let i = array.indexOf(target) - 1; i >= 0; i--) {
      if (array[i] === target - (count + 1)) {
          count ++;
      } else {
        break;
      }
  }

  return count;
}

function countConsecutiveNext(array, target) {
  let count = 0;

  for (let i = array.indexOf(target) + 1; i < array.length; i++) {
      if (array[i] === target + (count + 1)) {
          count ++;
      } else {
        break;
      }
  }

  return count;
}

function updateBundleProgress() {
  const step = 1 / bundleMinProductsRequirement
  const progress = totalItems() * step
  bundleProgressBar.style.setProperty('--scroll-progress', progress);

  const progressPagination = Math.floor((progress - 0.001) / 3)
  if(progressPagination > 0) {
    bundleProgressBarContainer.style.transform = `translateX(-${progressPagination}00%)`
  } else {
    bundleProgressBarContainer.style.transform = ""
  }

  if(bundleFreeProducts) {
    const nextProgress = totalItems() + 1;

    if(bundleFreeProducts.includes(nextProgress)) {
      // Duplicate and add a new indicator if not already present
      let duplicateIndicator = document.querySelector(`#bundle-progress--free-product-progress-bar-${nextProgress}`);
      if (!duplicateIndicator) {
        const bundleProgressBarFreeProduct = document.createElement("div");
        bundleProgressBarFreeProduct.classList.add("scrollbar__progress");
        bundleProgressBarFreeProduct.id = `bundle-progress--free-product-progress-bar-${nextProgress}`;
        bundleProgressBarFreeProduct.style.setProperty('--scroll-progress', step);
        bundleProgressBarFreeProduct.style.left = `calc(${progress} * 33% - 1px)`;
        bundleProgressBarFreeProduct.style.width = "34%";
        bundleProgressBarContainer.appendChild(bundleProgressBarFreeProduct);


        const bundleProgressBarFreeProductIndicator = document.createElement("div");
        bundleProgressBarFreeProductIndicator.classList.add("bundle-progress--indicator");
        bundleProgressBarFreeProductIndicator.id = `bundle-progress--free-product-indicator-${nextProgress}`;
        bundleProgressBarFreeProductIndicator.style.setProperty('--scroll-progress', step);
        bundleProgressBarFreeProductIndicator.style.left = `calc(${nextProgress * step} * 33% - 1px)`;
        const freeProductIndicatorProgress = countConsecutiveBefore(bundleFreeProducts, nextProgress) + 1;
        bundleProgressBarFreeProductIndicator.innerHTML = `+${freeProductIndicatorProgress}`;
        bundleProgressBarContainer.appendChild(bundleProgressBarFreeProductIndicator);
      }

      // Update message with the count of free products
      const freeProducts = countConsecutiveNext(bundleFreeProducts, nextProgress) + 1;
      bundleFreeProductMessage.querySelector("#pick-and-mix--free-product-message-content").textContent = bundleFreeProductMessage.dataset.message.toString().replace("{{ amount }}", freeProducts);
      bundleFreeProductMessage.classList.remove("hidden");
      bundleProductsQtyMessage.classList.add("hidden");
    } else {
      bundleFreeProductMessage.classList.add("hidden");
      bundleProductsQtyMessage.classList.remove("hidden");
      
      if (!bundleFreeProductMessage.classList.contains("q-active")) {
        bundleFreeProductMessage.classList.add("hidden");
      }
    }

    // Check if any duplicated indicators need to be removed
    const duplicateIndicators = () => document.querySelectorAll("[id^='bundle-progress--free-product-indicator-'], [id^='bundle-progress--free-product-progress-bar-']");
    duplicateIndicators().forEach(dupIndicator => {
      const dupProgress = parseInt(dupIndicator.id.split("-").pop(), 10);
      if (!bundleFreeProducts.includes(dupProgress) || nextProgress < dupProgress) {
        dupIndicator.remove();
      }
    });

    document.querySelectorAll('[id^="bundle-progress--free-product-indicator-"]').forEach(indicator => {
      const nextSibling = indicator.nextElementSibling;
      if (nextSibling && nextSibling.id.startsWith("bundle-progress--free-product-progress-bar-")) {
        const currentNum = parseInt(indicator.id.match(/\d+$/)[0], 10);
        const nextNum = parseInt(nextSibling.id.match(/\d+$/)[0], 10);

        indicator.style.display = nextNum === currentNum + 1 ? 'none' : '';
      } else {
        indicator.style.display = '';
      }
    });
  }
}

function updateProductsCount() {
  document.getElementById("pick-and-mix--total-ptoducts").textContent = totalItems();
}

function updateTotal() {
  const totalPrice = items.reduce((acc, item) => acc + item.price, bundlePrice);

  document.getElementById("pick-and-mix--total-price").textContent = formatMoney(totalPrice, currencyFormat);
}


document.querySelectorAll('.step-3 .reload .label, .step-3 .reload .number').forEach(label => {
    label.addEventListener('click', function() {
        location.reload();
    });
});